import React from 'react'
import QrReader from 'react-qr-reader'

export default function Home() {
    function errorH(e)
    {
        console.log(e);
    }
    function resH(e)
    {
        if(e !== null)
        {
            console.log(e);
        }
    }
    return (
        <div>
            <h1>Home</h1>
        <QrReader
            delay={300}
             onError={(err)=> errorH(err)}
             onScan={(res)=> resH(res)}
            style={{ width: '100%', height:"80%" }}
        />
        </div>
    )
}
